export default __webpack_public_path__ + "static/media/Monthly Budget.87d575dc.svg";